import gsap from 'gsap'

export function render () {
  const $lamp = document.querySelector('.c-lamp')
  const tl = gsap.timeline({ delay: 2 })

  if (!$lamp) return

  tl
    .to($lamp, {
      x: '5%',
      y: '-5%',
      ease: "Power3.easeInOut",
      duration: 1.5
    })
    .to($lamp, {
      x: '-12%',
      y: '-9%',
      scale: 2,
      ease: "Power3.easeInOut",
      duration: 3
    })
    .to($lamp, {
      x: '15%',
      y: '-9%',
      scale: 1,
      ease: "Power3.easeInOut",
      duration: 2
    })
    .to($lamp, {
      x: 0,
      y: 0,
      scale: 10,
      ease: "Power3.easeInOut",
      duration: 3
    })
    .to($lamp, {
      opacity: 0
    }, '-=.3')
}